<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="36" viewBox="0 0 40 36">
        <g id="Group_15022" data-name="Group 15022" transform="translate(-172 -137)">
            <g id="Group_15021" data-name="Group 15021" transform="translate(156 -147)">
                <rect id="Rectangle_10128" data-name="Rectangle 10128" width="40" height="36" transform="translate(16 284)" fill="#263238" opacity="0"/>
            </g>
            <g id="Rectangle_10124" data-name="Rectangle 10124" transform="translate(172 143)" fill="none" class="svg-stroke-color" stroke-width="1">
                <rect width="40" height="24" stroke="none"/>
                <rect x="0.5" y="0.5" width="39" height="23" fill="none"/>
            </g>
            <path id="Path_4460" :class="secondaryColor" data-name="Path 4460" d="M-14.388-12.885h2.6v6.979a14.476,14.476,0,0,0,.1,2.153,2.087,2.087,0,0,0,.8,1.27A2.771,2.771,0,0,0-9.176-2a2.622,2.622,0,0,0,1.67-.453,1.788,1.788,0,0,0,.677-1.112,14.5,14.5,0,0,0,.114-2.188v-7.128h2.6v6.768a17.389,17.389,0,0,1-.211,3.278A3.628,3.628,0,0,1-5.1-1.222,3.93,3.93,0,0,1-6.618-.171,6.6,6.6,0,0,1-9.1.22a7.136,7.136,0,0,1-2.8-.426A4,4,0,0,1-13.4-1.314a3.55,3.55,0,0,1-.729-1.428,15.648,15.648,0,0,1-.255-3.27Zm13.188,0H3.555a9.285,9.285,0,0,1,2.452.246A4.309,4.309,0,0,1,7.95-11.452,5.629,5.629,0,0,1,9.18-9.365,9.509,9.509,0,0,1,9.6-6.319a8.468,8.468,0,0,1-.4,2.742A5.681,5.681,0,0,1,7.827-1.3,4.573,4.573,0,0,1,6-.272,7.871,7.871,0,0,1,3.7,0H-1.2Zm2.6,2.18v8.534H3.344a7.088,7.088,0,0,0,1.573-.123,2.4,2.4,0,0,0,1.05-.536,2.728,2.728,0,0,0,.681-1.244,8.406,8.406,0,0,0,.264-2.36,7.7,7.7,0,0,0-.264-2.294,2.948,2.948,0,0,0-.738-1.248,2.476,2.476,0,0,0-1.2-.606,11.8,11.8,0,0,0-2.136-.123ZM11.909,0V-12.885h2.6V0Z" transform="translate(192 162)" />
        </g>
    </svg>

</template>

<script>
export default {
    name: "udiIcon",
    computed :{
        secondaryColor() {
            return 'svg-secondary-color';
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/info-popup/udiIcon.vue